//ARCGIS Start
import webMap from '@arcgis/core/WebMap';
import MapView from '@arcgis/core/views/MapView';
import Basemap from "@arcgis/core/Basemap";
import Extent from "@arcgis/core/geometry/Extent";
import esriConfig from "@arcgis/core/config";
import * as urlUtils from "@arcgis/core/core/urlUtils";
import WebTileLayer from "@arcgis/core/layers/WebTileLayer";
import './map.css';
export function initializeGoogleMap(options) {
    //#region start configer proxy on Map
    if (options.urlPrefix?.length > 0) {
        let item = options.urlPrefix;
        for (let index = 0; index < item.length; index++) {
            const el = item[index];
            urlUtils.addProxyRule({
                proxyUrl: options.proxyURL,
                urlPrefix: el
            });
        }
        esriConfig.request.proxyUrl = options.proxyURL;
    }
    if (options.urlsInterceptors?.length > 0) {
        esriConfig.request.interceptors?.push({
            urls: options.urlsInterceptors,
            headers: {
                'KACode': ''
            },
            before: options.injectSecurityCode
        });
    }
    //#endregion
    let googleLayer = new WebTileLayer({
        urlTemplate: options.baseMapURL,
        subDomains: ['0', '1', '2', '3'],
        title: options.title,
        id: options.id
    });
    let basemap = new Basemap({
        baseLayers: [googleLayer],
        thumbnailUrl: options.thumbnailUrl,
        title: options.title,
        id: options.id
    });
    const map = new webMap({
        basemap: basemap
    });
    const view = new MapView({
        container: options.divContainer,
        extent: new Extent({
            xmax: 65.94007328639653,
            xmin: 23.75248891122779,
            ymax: 33.42665681913392,
            ymin: 14.552107351284993,
        }),
        zoom: options.zoomlevel,
        map: map,
        constraints: {
            minScale: options.minScale
        }
    });
    view.when(() => {
        options.attributionControl == false ?
            view.ui.remove("attribution") : null;
        options.zoomControl !== "remove" ?
            view.ui.move(["zoom"], options.zoomControl) :
            view.ui.remove("zoom");
    }, (error) => {
        console.log('error', error);
    });
    return view;
}
